import React from 'react';

import {strings} from '../../../../../util/strings';
import {formatPhone} from '../../../../../util/utility';
import * as fonts from '../../../../../util/fonts';
import {Icons} from '../../../../../util/icons';
import Icon from '../../../../../components/icon';

import './styles.scss';
import {TelephoneIcon} from './TelephoneIcon';
import {connect} from 'react-redux';
import {compose} from 'redux';

interface PriceInterface {
  Value: number;
}

interface ItemInterface {
  latitude: number;
  longitude: number;
  code?: number;
  price: PriceInterface;
  name: string;
  address: string;
  postalCode: string;
  city: string;
  phone: number;
}

interface MapClinicInfoProps {
  item: ItemInterface;
  labels: typeof strings.pt.rede;
  withDirections?: boolean;
  buStyles: any;
  handleOnClickLocationDetails?(value: ItemInterface): void;
  handleClose(): void;
}

const MapClinicInfo = ({
  item,
  handleOnClickLocationDetails,
  handleClose,
  buStyles,
  labels,
  withDirections,
}: MapClinicInfoProps) => {
  const handleDetailsClick = () => {
    localStorage.setItem(
      'existingMarker',
      JSON.stringify({lat: item.latitude, lng: item.longitude})
    );
    handleOnClickLocationDetails && handleOnClickLocationDetails(item);
  };

  const onClose = (e: any) => {
    e.stopPropagation();

    handleClose();
  };

  return (
    <div
      ref={(ref: any) => ref && google.maps.OverlayView.preventMapHitsFrom(ref)}
      style={{...fonts.SM}}
      className="map-container">
      <div className="map-clinic-header">
        <span className="map-clinic-name">{item.name}</span>
        <Icon
          className="cross-close svg-close-button"
          name={Icons.CLOSE}
          width={'12'}
          height={'12'}
          changeViewbox={false}
          strokeWidth={'0.5'}
          onClick={onClose}
          color={buStyles?.primaryColor}
        />
      </div>
      <span className="map-clinic-address">
        {`${item.address}, ${item.postalCode}, ${item.city}`}
      </span>
      <div className="map-clinic-phone-container">
        <TelephoneIcon
          color={buStyles.primaryColor}
          width="17px"
          height="17px"
        />
        <a
          href={`tel:${item.phone}`}
          className="map-clinic-phone"
          style={{color: buStyles.primaryColor}}>
          {item.phone ? formatPhone(item.phone.toString()) : ''}
        </a>
      </div>
      {withDirections ? (
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${item.latitude},${item.longitude}`}
          className="map-clinic-directions-button"
          rel="noopener noreferrer"
          style={{color: buStyles.primaryColor}}
          onClick={(e) => e.stopPropagation()}
          target="_blank">
          {labels?.medicalNetwork_locations_see_directions}
        </a>
      ) : (
        <button
          onClick={handleDetailsClick}
          className="map-clinic-details-button"
          style={{backgroundColor: buStyles.primaryColor}}>
          {labels?.medicalNetwork_locations_view_details}
        </button>
      )}
    </div>
  );
};

const mapStateToProps = ({strings}: any) => ({
  labels: strings.value.pt.rede,
});

export default compose(connect(mapStateToProps)(MapClinicInfo));
